import React from 'react';
import LoadingSpinner from './LoadingSpinner';

const LocalScreenLoadingSpinner = () => {
  return (
    <div className={'local-screen-loading-spinner'}>
      <LoadingSpinner />
    </div>
  );
};

export default LocalScreenLoadingSpinner;
